import React from "react";

import ResetPasswordPageLayer from "../components/ResetPasswordLayer";

const RegisterPage = () => {
  return (
    <>

        {/* Reset Password Page Layer */}
        <ResetPasswordPageLayer />

    </>
  );
};

export default RegisterPage; 
